import React from "react";

import { BlockNotFound } from "../components/BlockNotFound";

const NotFound = () => {
  return (
    <BlockNotFound />
  );
};

export default NotFound;